export const themes = [
  {
    name: "dark",
    colorWhite: "#fff",
    colorBlack: "#000",
    colorPrimary: "#ff4c60",
    colorBg: "#1E1E1E",
    colorBg2: "#131313",
    colorBg3: "#222121",
    colorBg4: "#1f1e1d",
    colorBg5: "#262626",
    colorBg6: "#202020",
    colorBgGrad: "linear-gradient(180deg,#222121,#191919)",
    aboutBg: "#191919",
    colorGreen: "#6BBE92",
    colorGreenDark: "#27AE60",
    colorYellow: "rgb(249, 215, 76)",
    colorPurple: "rgb(108, 108, 229)",
    colorGrey: "#3c3c3c",
    colorGrey0: "#f8f8f8",
    colorGrey1: "#dbe1e8",
    colorGrey2: "#b2becd",
    colorGrey3: "#6c7983",
    colorGrey4: "#454e56",
    boxShadow1: "0 3px 15px rgba(0,0,0,.3)",
    bPad1: "1rem 2rem",
    shadowPurple: "rgb(108 108 229 / 30%) 0px 5px 20px 0px",
    shadowGreen: "rgb(107 190 146 / 30%) 0px 5px 20px 0px",
    shadowPrimary: "rgb(255 76 96 / 30%) 0px 5px 20px 0px",
  },
];
